<template>
  <div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
        <!-- Modal Header -->
        <div class="modal-header">
          <slot name="header"></slot>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <slot name="body"></slot>

            <div class="margin-bottom-10"></div>
            <div>
               <b-card no-body>
                  <div class="row tasks_heading_row">
                     <div
                       class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3"
                       v-on:click="sortMethod('naicsId')"
                       >
                       NAICS ID
                       <i v-if="sortField == 'naicsId' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'naicsId' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                     </div>
                     <div
                       class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                       v-on:click="sortMethod('naicsCode')"
                       >
                       NAICS Number
                       <i v-if="sortField == 'naicsCode' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'naicsCode' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                     </div>
                     <div
                       class="bold cursor-pointer col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding"
                       v-on:click="sortMethod('description')"
                       >
                       NAICS Description
                       <i v-if="sortField == 'description' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'description' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                     </div>
                   </div>

                   <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>

                     <b-card-text v-if="naics_lists.length > 0">
                        <div v-for="(naicslist, index) in naics_lists" class="tasklist-row">
                          <div class="row tasklist-item cursor-pointer" v-on:click="naicsValues(naicslist)">
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 naics-title">{{naicslist.naicsCat}}</div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{naicslist.naicsCode}}</div>
                            <div class="col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding">{{naicslist.description}}</div>
                          </div>
                          <div><hr></div>
                        </div>
                     </b-card-text>
                     <b-card-text v-else-if="loading == false">
                          No records found
                     </b-card-text>
               </b-card>
             </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';

export default {
        data() {
          return {
            rows: 0,
            perPage: 25,
            currentPage: 1,
            naics_lists: [],
            search_keyword: '',
            search_status: '',
            id: '',
            sortField: '',
            tasklist_title: '',
            naics_id: '',
            naics_title: '',
            naics_code: '',
            naicsIdOptions: [{value: '', text: 'Select NAICS ID'}],
            loading: false,
          }
        },
        props: ['isModalVisible'],
        methods: {
            closeModal() {
              this.$emit('close');
            },
            isActive: function (tabvalue) {
                 return this.selectedComponent === tabvalue
            },
            fetchNaicsListitems() {
              this.loading = true;
              const params = {};
              if (this.sortField) {
                params.sortfield = this.sortField
              }
              if (this.publicSortBy) {
                params.sortby = this.publicSortBy
              }
              params.no_page = 'true';
              axios.get('/naicslists', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.naics_lists = resp.data.data;
              })
              .catch(error => {

              });
            },
            naicsValues: function(naicslist) {
              this.$parent.naicsValuesAction(naicslist);
            },
           sortMethod: function(field) {
             this.sortField = field;
             this.naics_lists = [];
             if(this.publicSortBy == 'ASC') {
               this.publicSortBy = 'DESC';
             }
             else {
               this.publicSortBy = 'ASC';
             }
             this.fetchNaicsListitems();
           },
          },
         created() {
           this.fetchNaicsListitems();
           document.body.className = 'naicslist-page';
         },
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 25px;
  color: #FFF;
  padding: 3px 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.input-height-30 {
  line-height: 30px;
}
.naics-code-wrapper {
  padding-left: 15px;
}
hr {
  border-top: 2px solid #8b8b8b;
  margin: 0px;
}
.tasklist-row:nth-of-type(odd) {
  background-color:#fff;
}
.tasklist-row:nth-of-type(even) {
  background-color:#e9e9e9;
}
.search-wrapper {
  background-color: transparent;
}
.heading-seperator {
  border-bottom: 2px solid #4c94cf;
}
.btn-blue {
  background-color: #4c94cf !important;
  border: 1px solid #4c94cf !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
}
.heading {
  font-size: 15px;
}
.tasklist-item {
  padding: 8px 0px 8px 0px;
}
.naics-title {
  padding-left: 20px;
}
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 90%;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;

}
.modal-body {
    margin: 0px;
    padding: 10px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 760px;
}
@media(max-width:560px) {
  .modal-container {
    width: 98%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
      height: 360px;
      overflow-y: scroll;
  }
}

.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.btn-info, .btn-info:hover, .btn-info:focus {
  background-color: #C3C3C3 !important;
  border: 1px solid #CCC !important;
  color: #000;
}
.btn {
  padding: 1px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_naics_list.vue